import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux'
import { PersistGate } from 'redux-persist/integration/react'
import { store, persistor, history } from './Redux'
import * as Sentry from "@sentry/react";
import { createTheme, ThemeProvider } from '@material-ui/core/styles';
import './index.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Client-only app, so media queries can match on the first render. Without this
// useMediaQuery returns false until after mount, e.g. the booking calendar first
// fetches a single day as if on mobile, then refetches the week and grows.
const theme = createTheme({
    props: {
        MuiUseMediaQuery: { noSsr: true },
    },
});

Sentry.init({
    environment: process.env.REACT_APP_SENTRY_ENVIRONMENT || 'production',
    dsn: "https://3e28099773c24d119316c4521641c188@o4505319964803072.ingest.us.sentry.io/4505319990034432",
    // This sets the sample rate to be 10%. You may want this to be 100% while
    // in development and sample at a lower rate in production
    replaysSessionSampleRate: 0.1,
    // If the entire session is not sampled, use the below sample rate to sample
    // sessions when an error occurs.
    replaysOnErrorSampleRate: 1.0,
    integrations: [
        Sentry.replayIntegration(),
    ],
});

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
          <ThemeProvider theme={theme}>
              <App  history={history} />
          </ThemeProvider>
      </PersistGate>
    </Provider>
  </React.StrictMode >,
  document.getElementById('root'),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
